/* FHS product page enhancements — Oct 2026 redesign
   1. Copy notes follow the selected Condition variant
   2. Quantity selector hidden when only one copy of the selected variant exists
   3. Details accordion: ISBN / weight / copy follow the variant
   4. Description clean-up: hide "Product Edition: Unknown" and the duplicated Condition list
   5. Mobile sticky add-to-cart bar
   6. Quantity box sits to the left of Add to cart (Greg, Sep 25)
   7. "Related products" fallback (Greg, Sep 28): when the product has no Common Title
      family list, replace Shopify's guesses with "More from <publisher>" (same subject
      first, then any), then "More in <subject>"; leave Shopify's list only when none apply.
*/
(function () {
  'use strict';

  function moneyFromCents(cents) {
    try {
      var code = document.querySelector('variant-selects')?.dataset.currencyCode || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function init() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var sectionEl = info.closest('section[id^="ProductInfo-"]');
    var sectionId = sectionEl ? sectionEl.id.replace('ProductInfo-', '') : null;
    var notesWrap = info.querySelector('[data-fhs-variant-notes]');
    var qtyForm = sectionId ? document.getElementById('Quantity-Form-' + sectionId) : info.querySelector('.product-form__quantity');
    var form = info.querySelector('form.product-form') || document.querySelector('form[id^="product-form-"]');
    var addBtn = info.querySelector('.product-form__submit');

    /* ---- 1 + 2 + 3: variant-driven bits ---- */
    function applyVariant(variant) {
      var id = variant && variant.id;
      var item = null;
      if (notesWrap) {
        notesWrap.querySelectorAll('.fhs-variant-notes__item').forEach(function (el) {
          var match = String(el.dataset.variantId) === String(id);
          el.classList.toggle('hidden', !match);
          if (match) item = el;
        });
      }
      if (qtyForm) {
        var hide = false;
        if (item) {
          var managed = item.dataset.managed === '1';
          var inv = parseInt(item.dataset.inventory, 10);
          var policy = item.dataset.policy;
          if (managed && policy !== 'continue' && !isNaN(inv) && inv <= 1) hide = true;
        }
        qtyForm.classList.toggle('fhs-qty-hidden', hide);
        if (hide) {
          var input = qtyForm.querySelector('input.quantity__input');
          if (input) input.value = 1;
        }
      }
      if (variant) {
        var copy = document.querySelector('[data-fhs-copy]');
        if (copy && variant.title) copy.textContent = variant.title;
        var isbn = document.querySelector('[data-fhs-isbn]');
        if (isbn && variant.barcode && (variant.barcode.length === 10 || variant.barcode.length === 13)) isbn.textContent = variant.barcode;
      }
      updateSticky(variant);
    }

    function currentVariant() {
      try {
        var s = document.querySelector('variant-selects [data-selected-variant]') || document.querySelector('[data-selected-variant]');
        return s ? JSON.parse(s.textContent) : null;
      } catch (e) { return null; }
    }

    /* ---- 4: description clean-up (until n8n stops writing these lines) ---- */
    function cleanDescription() {
      var desc = info.querySelector('.product__description');
      if (!desc) return;
      var hasPicker = !!info.querySelector('variant-selects');
      desc.querySelectorAll('li').forEach(function (li) {
        var t = (li.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^Product Edition:\s*(Unknown( Edition)?|Other|N\/A)?$/i.test(t)) li.remove();
        else if (hasPicker && /^Condition:\s*Multiple copies/i.test(t)) li.remove();
      });
      desc.querySelectorAll('ul').forEach(function (ul) { if (!ul.children.length) ul.remove(); });
    }

    /* ---- 5: mobile sticky bar ---- */
    var sticky = null, stickyBtn = null, stickyPrice = null;
    function buildSticky() {
      if (!addBtn || sticky) return;
      sticky = document.createElement('div');
      sticky.className = 'fhs-sticky';
      var titleEl = info.querySelector('.product__title h1');
      sticky.innerHTML =
        '<div class="fhs-sticky__meta"><p class="fhs-sticky__title"></p><p class="fhs-sticky__price"></p></div>' +
        '<button type="button" class="fhs-sticky__btn">Add to cart</button>';
      sticky.querySelector('.fhs-sticky__title').textContent = titleEl ? titleEl.textContent.trim() : '';
      stickyPrice = sticky.querySelector('.fhs-sticky__price');
      stickyBtn = sticky.querySelector('.fhs-sticky__btn');
      stickyBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        addBtn.click();
      });
      document.body.appendChild(sticky);
      document.body.classList.add('fhs-sticky-active');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }, { threshold: 0 });
        io.observe(addBtn);
      } else {
        sticky.classList.add('is-visible');
      }
    }
    function updateSticky(variant) {
      if (!sticky) return;
      var v = variant || currentVariant();
      if (v) {
        stickyPrice.textContent = moneyFromCents(v.price);
        var soldOut = !v.available;
        stickyBtn.disabled = soldOut;
        stickyBtn.textContent = soldOut ? 'Sold out' : 'Add to cart';
      }
    }

    /* ---- 6: Quantity next to Add to cart (Greg, Sep 25) ---- */
    (function placeQty() {
      if (!qtyForm || !addBtn) return;
      var buttons = addBtn.closest('.product-form__buttons');
      if (!buttons || buttons.contains(qtyForm)) return;
      buttons.classList.add('fhs-row');
      buttons.insertBefore(qtyForm, addBtn);
    })();

    /* ---- 7: Related products fallback (Greg, Sep 28) ---- */
    function relatedFallback() {
      var metaEl = document.getElementById('fhs-product-meta');
      var rec = document.querySelector('product-recommendations.related-products');
      if (!metaEl || !rec) return;
      var meta;
      try { meta = JSON.parse(metaEl.textContent); } catch (e) { return; }
      if (meta.familyCount > 0) return;              // family list exists → Shopify shows it
      var vendor = (meta.vendor || '').trim();
      var subject = (meta.subject || '').trim();
      var handle = meta.handle;
      var searchUrl = meta.searchUrl || '/search';

      var tiers = [];
      if (vendor && subject) tiers.push({ q: 'vendor:"' + vendor + '" tag:"' + subject + '"', heading: 'More from ' + vendor });
      if (vendor) tiers.push({ q: 'vendor:"' + vendor + '"', heading: 'More from ' + vendor });
      if (subject) tiers.push({ q: 'tag:"' + subject + '"', heading: 'More in ' + subject });
      if (!tiers.length) return;

      function fetchTier(i) {
        if (i >= tiers.length) return Promise.resolve(null);
        var t = tiers[i];
        var url = searchUrl + '?type=product&options%5Bprefix%5D=none&options%5Bunavailable_products%5D=hide&sort_by=created-descending&section_id=fhs-search-cards&q=' + encodeURIComponent(t.q);
        return fetch(url, { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var items = Array.prototype.slice.call(doc.querySelectorAll('.fhs-search-cards > li'))
              .filter(function (li) { return li.dataset.handle !== handle; })
              .slice(0, 6);
            if (items.length >= 2) return { heading: t.heading, items: items };
            return fetchTier(i + 1);
          })
          .catch(function () { return fetchTier(i + 1); });
      }

      fetchTier(0).then(function (res) {
        if (!res) return;                              // nothing found → leave Shopify's list
        var wrap = document.createElement('div');
        wrap.className = rec.className;                // same layout classes as the Dawn section
        wrap.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--slide-in');
        wrap.classList.add('fhs-related');
        var h = document.createElement('h2');
        h.className = 'related-products__heading inline-richtext h2';
        h.textContent = res.heading;
        var ul = document.createElement('ul');
        ul.className = 'grid product-grid grid--6-col-desktop grid--2-col-tablet-down';
        ul.setAttribute('role', 'list');
        res.items.forEach(function (li) { ul.appendChild(li); });
        wrap.appendChild(h);
        wrap.appendChild(ul);
        rec.parentNode.insertBefore(wrap, rec);
        rec.setAttribute('hidden', '');
        rec.style.display = 'none';
      });
    }

    cleanDescription();
    buildSticky();
    applyVariant(currentVariant());
    relatedFallback();

    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var v = event && event.data && event.data.variant;
        // Dawn re-renders parts of the section; re-query after it settles
        setTimeout(function () { applyVariant(v || currentVariant()); }, 50);
      });
    } else {
      // Fallback: watch the selected-variant JSON node
      var mo = new MutationObserver(function () { applyVariant(currentVariant()); });
      var vs = document.querySelector('variant-selects');
      if (vs) mo.observe(vs, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
